import {o} from "odata";
import {$ctx} from "@themeConfig";

const accessToken = localStorage.getItem("accessToken");
const config = {
    headers: new Headers({
      "Content-Type": "application/json",
      apiKey: accessToken
    }),
    mode: "cors"
};
const useOdata = o($ctx.API_URL, config);

export default useOdata;
